export const primaryKeywords = {
  finanzcoaching: "Finanzcoaching",
  executiveCoaching: "Executive Coaching", 
  katalysatorFuehrung: "Katalysator-Führung",
  outdoorCoaching: "Outdoor-Coaching",
  walkTalkCoaching: "Walk & Talk Coaching",
  fuehrungskraefteCoaching: "Führungskräfte-Coaching"
};

export const secondaryKeywords = {
  finanzielleFreiheit: "finanzielle Freiheit",
  finanzielleSelbstbestimmung: "finanzielle Selbstbestimmung", 
  geldGlaubenssaetze: "Geld-Glaubenssätze",
  finanzielleIntelligenz: "finanzielle Intelligenz",
  fuehrungsexzellenz: "Führungsexzellenz",
  emotionaleIntelligenz: "emotionale Intelligenz",
  selbstfuehrung: "Selbstführung",
  resilienz: "Resilienz",
  changeManagement: "Change Management",
  coachingNatur: "Coaching in der Natur"
};

export const locationKeywords = {
  nuernberg: "Nürnberg",
  rothsee: "Rothsee", 
  bayern: "Bayern",
  metropolregion: "Metropolregion Nürnberg",
  franken: "Franken"
};

// Keyword clusters für verschiedene Seiten
export const keywordClusters = {
  homepage: [
    primaryKeywords.executiveCoaching,
    primaryKeywords.finanzcoaching,
    primaryKeywords.katalysatorFuehrung,
    secondaryKeywords.fuehrungsexzellenz,
    secondaryKeywords.finanzielleSelbstbestimmung,
    locationKeywords.nuernberg
  ],
  coaching: [
    primaryKeywords.finanzcoaching,
    secondaryKeywords.finanzielleSelbstbestimmung,
    secondaryKeywords.geldGlaubenssaetze,
    secondaryKeywords.finanzielleIntelligenz,
    locationKeywords.nuernberg
  ],
  consulting: [
    primaryKeywords.executiveCoaching,
    primaryKeywords.katalysatorFuehrung,
    primaryKeywords.fuehrungskraefteCoaching,
    secondaryKeywords.fuehrungsexzellenz,
    secondaryKeywords.emotionaleIntelligenz
  ],
  outdoorCoaching: [
    primaryKeywords.outdoorCoaching,
    primaryKeywords.walkTalkCoaching,
    secondaryKeywords.coachingNatur,
    locationKeywords.rothsee,
    locationKeywords.bayern
  ]
};